module.exports = __webpack_public_path__ + "static/media/we see.dced44ac.png";